var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialPad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 36,
    viewBox: "0 0 26 36",
    fill: "none",
    style: {
      marginTop: 6
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    fill: "#ffffff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 3,
    r: 3,
    fill: "#ffffff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 3,
    r: 3,
    fill: "#ffffff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 13,
    r: 3,
    fill: "#ffffff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 3,
    fill: "#ffffff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 13,
    r: 3,
    fill: "#ffffff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 23,
    r: 3,
    fill: "#ffffff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 23,
    r: 3,
    fill: "#ffffff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 3,
    fill: "#ffffff"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 33,
    r: 3,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialPad);
export default __webpack_public_path__ + "static/media/dialPad.03eb513170d79590b84d1675b5aa2e3d.svg";
export { ForwardRef as ReactComponent };